import { Field, Form, Formik, FormikHelpers } from 'formik'
import { FC, ReactElement, useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import * as yup from 'yup'
import Button from '../../components/button'
import H3 from '../../components/h3'
import Input from '../../components/input'
import Modal from '../../components/modal'
import { useAuth } from '../../hooks/auth'
import { VerificationCode } from '../register/style'
import { ContainerVerify } from './style'

const schema = yup.object().shape({
  token: yup.string().min(4, 'Código inválido').required('Digite o código')
})

const VerifyPhone: FC = (): ReactElement | null => {
  const { search } = useLocation()
  const history = useHistory()
  const query = new URLSearchParams(search)

  const verifyPhone = query.get('verifyPhone')

  const [isLoading, setIsLoading] = useState(false)

  const { user, requestValidatePhone, validatePhone } = useAuth()

  const infoPhone = `Digite o código de 5 dígitos enviado para o telefone ${user?.phone}`

  const initialValues = {
    token: ''
  }

  const submit = async (values: typeof initialValues, helpers: FormikHelpers<typeof initialValues>): Promise<void> => {
    helpers.setSubmitting(true)
    try {
      // if (email) {
      await validatePhone(values.token)
      history.push({ search: '' })
      // }
    } catch { }
    helpers.setSubmitting(false)
  }

  const resendToken = useCallback(async () => {
    setIsLoading(true)
    try {
      await requestValidatePhone()
    } catch {}
    setIsLoading(false)
  }, [setIsLoading])

  useEffect(() => {
    if (verifyPhone) {
      resendToken()
    }
  }, [resendToken, verifyPhone])

  if (!verifyPhone) return null

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      onSubmit={submit}
    >
      {({ isSubmitting, submitForm, isValid }) => (
        <Form>
          <Modal
            isLoading={isSubmitting}
            okButtonText='Validar telefone'
            onOk={submitForm}
            variantButton={isValid ? 'primary' : 'muted'}
            footerComponent={(
              <Button
                variant='link'
                block
                size='sm'
                isLoading={isLoading}
                onClick={resendToken}
              >
                Não recebeu o código? Enviar novamente!
              </Button>
            )}
          >
            <ContainerVerify>
              <H3>Validação de cadastro</H3>
              <span>
                Pedimos a validação para o paciente de acordo com as normas de
                LGPD e segurança da informação. O médico é responsável pelas informações
                salvas de cada paciente.
              </span>
            </ContainerVerify>
            <VerificationCode>
              <Field
                name='token'
                component={Input}
                label='Código de verificação telefone'
                info={infoPhone}
                maxLength={4}
              />
            </VerificationCode>
          </Modal>
        </Form>
      )}
    </Formik>
  )
}

export default VerifyPhone
